import * as bucketConstants from '../constants/buckets';

const INITIAL_STATE = {
    newBucketName: undefined,
    loading: false,
    error: undefined,
    newAppsIds: undefined,
};

export default function bucketSettings(state = {}, action) {
    switch (action.type) {
        case bucketConstants.RESET_BUCKET_SETTINGS:
            return {
                ...INITIAL_STATE,
            };
        case bucketConstants.CHANGE_BUCKET_SETTINGS_NAME:
            return {
                ...state,
                newBucketName: action.payload,
            };
        case bucketConstants.CHANGE_BUCKET_SETTINGS_APPLICATION_IDS:
            return {
                ...state,
                newAppsIds: [...action.payload],
            };
        case bucketConstants.UPDATE_BUCKET_SETTINGS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case bucketConstants.UPDATE_BUCKET_SETTINGS_SUCCESS:
            return {
                ...state,
                ...INITIAL_STATE,
            };
        case bucketConstants.UPDATE_BUCKET_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/bucketSettingsReducer.js